import { ENDPOINTS_MASTER } from "@/constants/table-master";
import type { MESSAGE_ERROR_HTTP } from "@/interfaces/http-client";
import type { ParameterTableMap, ResultParameterTableResponse } from "@/interfaces/table-master";
import { HTTP_STATUS_CODE, httpClient } from "@/lib/httpClientAxios";
import { getApiUxHeaders, getMessageError } from "@/mappings/httpClient";
import { mapToParameterTable } from "@/mappings/master-table";
import { getEnvironmentVariable } from "@/utils/environment";

const parameterTableError: Partial<MESSAGE_ERROR_HTTP> = {
    'default': 'Hubo un error desconocido al obtener los parametros configurables.',
    404: "Parametros configurables configurables no encontrado"
};

export const getParameterTable = async (): Promise<ParameterTableMap[] | null> => {
    try {
        const urlTableMasterApi = getEnvironmentVariable("VITE_APP_URL_MASTER_TABLE","");
        const headers = getApiUxHeaders();
        let endpoint = ENDPOINTS_MASTER.PARAMETERS;

        const { data, status_code } = await httpClient.get<ResultParameterTableResponse>(
            `${urlTableMasterApi}${endpoint}`,
            { headers },
        );
        if (status_code === HTTP_STATUS_CODE.OK && data?.datos) {
            return mapToParameterTable(data);
        }

        return null;
    } catch (error) {
        throw new Error(getMessageError(error, parameterTableError));
    }
};
